import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {classNames} from "helpers/classNames";
import {useNewsUnreadCount} from "hooks/useQuery/news/useNewsUnreadCount";

export const NewsSupportButton = () => {
    const { t } = useTranslation("profile");
    const unreadCount = useNewsUnreadCount();

    return (
        <Link
            to="/newsSuggestions"
            className={classNames("profile-page__psych-suggestions", {
                "profile-page__psych-suggestions_notice": unreadCount > 0,
            })}
        >
            <div>
                <p>{t("suggestions_btn_text_with_news")}</p>
                <p className="profile-page__psych-suggestions__phone">{t("suggestions_btn_description")}</p>
            </div>
            {unreadCount > 0 && <span>{unreadCount}</span>}
        </Link>
    );
};
